import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconNutshellToGoogleCalendar = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 268 72",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#FE5800",
			d: "M35.855 12.788a2.1 2.1 0 0 1-.878-.229 2.1 2.1 0 0 1-.701-.576 2.11 2.11 0 0 1-.411-1.724l1.431-7.613a1.7 1.7 0 0 0 .04-.354c0-1.616-2.262-1.827-5.193-1.827s-5.2.211-5.2 1.827q.001.18.04.354l1.452 7.613a2.127 2.127 0 0 1-2.044 2.508C10.363 13.258.467 17.853.467 26.23v3.224a1.54 1.54 0 0 0 1.54 1.54h25.526a1.48 1.48 0 0 1 1.547 1.54 1.43 1.43 0 0 1-1.227 1.439L8.925 37.639a1.445 1.445 0 0 0-1.227 1.492v6.482c0 12.446 9.733 22.922 22.445 22.922a22.49 22.49 0 0 0 22.493-22.492V32.452a1.494 1.494 0 0 1 1.54-1.486h4.09a1.54 1.54 0 0 0 1.567-1.54v-3.224c0-8.398-9.896-12.664-23.978-13.414"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#4D4540",
			d: "M100.033 31.15a3.35 3.35 0 0 0 0 6.7zm62.669 5.719a3.35 3.35 0 0 0 0-4.738l-21.319-21.32a3.35 3.35 0 0 0-4.738 4.739l18.951 18.95-18.951 18.95a3.35 3.35 0 0 0 4.738 4.738zm-62.669.981h60.3v-6.7h-60.3z"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "a-nutshell-to-google-calendar",
			width: 68,
			height: 67,
			x: 200,
			y: 1,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "luminance" },
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M267.533 1h-67v67h67z"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#a-nutshell-to-google-calendar)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M251.665 16.869h-35.263v35.263h35.263z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#EA4335",
					d: "m251.665 68 15.869-15.869-7.934-1.353-7.935 1.353-1.448 7.258z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#188038",
					d: "M200.533 52.131v10.58a5.29 5.29 0 0 0 5.29 5.289h10.579l1.629-7.934-1.629-7.935-8.646-1.353z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#1967D2",
					d: "M267.534 16.869V6.289A5.29 5.29 0 0 0 262.245 1h-10.58q-1.448 5.903-1.448 8.688t1.448 7.18q5.265 1.509 7.935 1.508t7.934-1.507"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#FBBC04",
					d: "M267.533 16.869h-15.868v35.263h15.868z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#34A853",
					d: "M251.665 52.131h-35.263V68h35.263z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#4285F4",
					d: "M251.665 1h-45.842a5.29 5.29 0 0 0-5.29 5.29v45.842h15.869V16.869h35.263z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#4285F4",
					d: "M223.635 44.224c-1.318-.89-2.231-2.19-2.729-3.91l3.06-1.26q.416 1.586 1.454 2.46 1.034.87 2.504.868 1.5 0 2.578-.913 1.08-.913 1.08-2.323 0-1.44-1.137-2.354c-.758-.608-1.71-.912-2.847-.912h-1.768v-3.028h1.587q1.467 0 2.473-.794 1.005-.792 1.005-2.173 0-1.229-.899-1.961-.899-.736-2.279-.736-1.35-.001-2.143.718a4.2 4.2 0 0 0-1.155 1.768l-3.028-1.261q.6-1.707 2.217-3.01 1.621-1.305 4.135-1.305 1.86-.001 3.341.718 1.483.721 2.323 1.993.839 1.274.838 2.86 0 1.62-.78 2.742a5.4 5.4 0 0 1-1.918 1.723v.18a5.8 5.8 0 0 1 2.46 1.918q.96 1.289.961 3.086 0 1.8-.913 3.209c-.608.939-1.45 1.68-2.517 2.217q-1.606.809-3.61.811c-1.547.005-2.975-.44-4.293-1.33m18.79-15.18-3.358 2.428-1.68-2.548 6.026-4.346h2.31V45.08h-3.298z"
				})
			]
		})
	]
});
export default SvgIconNutshellToGoogleCalendar;
